import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "w-100 d-flex flex-column flex-center rounded-3 bg-light bg-opacity-75 py-15 px-10" }
const _hoisted_2 = { class: "mb-7 text-center" }
const _hoisted_3 = { class: "text-dark mb-5 fw-boldest" }
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "mb-2 text-primary" }, "$", -1)
const _hoisted_6 = {
  class: "fs-3x fw-bolder text-primary",
  "data-kt-plan-price-month": "39",
  "data-kt-plan-price-annual": "399"
}
const _hoisted_7 = { class: "fs-7 fw-bold opacity-50" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("/ ")
const _hoisted_9 = { "data-kt-element": "period" }
const _hoisted_10 = { class: "w-100 mb-10" }
const _hoisted_11 = { class: "fw-bold fs-6 text-gray-800 flex-grow-1 pe-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    opacity: "0.3",
    x: "2",
    y: "2",
    width: "20",
    height: "20",
    rx: "10",
    fill: "black"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M10.4343 12.4343L8.75 10.75C8.33579 10.3358 7.66421 10.3358 7.25 10.75C6.83579 11.1642 6.83579 11.8358 7.25 12.25L10.2929 15.2929C10.6834 15.6834 11.3166 15.6834 11.7071 15.2929L17.25 9.75C17.6642 9.33579 17.6642 8.66421 17.25 8.25C16.8358 7.83579 16.1642 7.83579 15.75 8.25L11.5657 12.4343C11.2533 12.7467 10.7467 12.7467 10.4343 12.4343Z",
    fill: "black"
  })
], -1)
const _hoisted_13 = [
  _hoisted_12
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.plan.name), 1),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.price), 1),
        _createElementVNode("span", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.frequency), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.services, (service, key) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "d-flex align-items-center mb-5",
          key: key
        }, [
          _createElementVNode("span", _hoisted_11, _toDisplayString(service), 1),
          _createElementVNode("span", {
            class: _normalizeClass(["svg-icon svg-icon-1", { 'svg-icon-success': _ctx.hasService(service) }])
          }, _hoisted_13, 2)
        ]))
      }), 128))
    ]),
    _createElementVNode("a", {
      href: "#",
      class: "btn btn-sm btn-primary",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.choosePlan(_ctx.plan)))
    }, "Select")
  ]))
}